'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListViewButton = require('./components/ListViewButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListViewButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-list-view-button/lib/index.js
// module id = 1331
// module chunks = 1